"use strict";

class DeveloperReportsController {

    constructor($scope, $timeout, $parse, SSHttpService, SSUtilService, SSAppService, SSAlertService, OTPService, SSUserService, SSDateService, SSAnalyticsService) {
        const self = this;

        self.$scope = $scope;
        self.$parse = $parse;
        self.$timeout = $timeout;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAppService = SSAppService;
        self.SSAlertService = SSAlertService;
        self.OTPService = OTPService;
        self.SSUserService = SSUserService;
        self.SSDateService = SSDateService;
        self.SSAnalyticsService = SSAnalyticsService;

        self.data = SHOWSUITE.data;
        self.LARAVEL_REPORT_SERVER_URL = SHOWSUITE.LARAVEL_REPORT_SERVER_URL;

        self.filtered_properties = [];

        self.allReportStatus = [
            {
                id: 11,
                name: 'All'
            },
            {
                id: 30,
                name: 'OTP Issued'
            },
            {
                id: 32,
                name: 'SPA Issued'
            },
            {
                id: 37,
                name: 'Exercised'
            },
            {
                id: 35,
                name: 'OTP Aborted'
            }
        ];

        self.optionIssuedReportStatuses = [
            {
                id: 11,
                name: 'All'
            },
            {
                id: 51,
                name: 'OTP Issued'
            },
            {
                id: 35,
                name: 'OTP Aborted'
            }
        ];

        self.uraReportStatuses = [

            {
                id: 1,
                name: 'All'
            },
            {
                id: 2,
                name: 'Sold'
            },
            {
                id: 3,
                name: 'Aborted'
            },
            {
                id: 4,
                name: 'Re-issue'
            }
        ];

        self.reportParamErrors = {};

        // WEB-4823: law firm filter of a report with show_law_firm (R111); [] until a project is chosen
        self.reportLawFirms = [];
        self.reportLawFirmsLoading = false;
        self.reportLawFirmsFailed = false;
        // property id => [{id, name}] from GET sec/developer/law-firms/assigned, kept for the page
        self.reportLawFirmsByProperty = {};
        self.reportLawFirmsSeq = 0;

        // Handed to Angular's `filter:` as a bare predicate, which invokes it without a
        // receiver - and this file is strict mode, so `this` would otherwise be undefined.
        self.matchesReportSearch = self.matchesReportSearch.bind(self);

        if (self.SSUserService.isDeveloper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        // Trigger View Event for Reports Page
        self.SSAnalyticsService.saveAnalyticEvent({
                event: self.SSAnalyticsService.ANALYTICS_EVENT_VIEWS_DMS_REPORTS,
                user_id: self.SSUtilService.getFromLocalStorage('user').id
            }
        );

        self.getDeveloper();
        self.getAllReports();
    }

    getAllReports() {
        const self = this;

        self.reports = null;

        let url = 'sec/super/reports';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.reports = response.data.reports;

            // The "All" tab collapses assignment rows to distinct reports and needs the
            // catalogue for its tie-break. This request and getDeveloperReports() are
            // independent and either can resolve first, so rebuild from both callbacks.
            self.setDistinctDeveloperReports();
        });
    }

    getDeveloper() {
        const self = this;

        self.selectedDeveloper = null;

        let url = 'sec/developer/profile';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.selectedDeveloper = response.data.developer;
            self.getProperties();
            self.getDeveloperReports();
        });
    }

    getDeveloperReports() {
        const self = this;

        self.developerReports = null;
        self.developerReportCategories = null;
        self.distinctDeveloperReports = null;

        let url = 'sec/super/developer-reports';
        let params = {
            developer_id: self.selectedDeveloper.id
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.developerReports = response.data.developer_reports;
            self.developerReportCategories = response.data.developer_report_categories;

            // Reports may reference categories not present in developer_report_categories;
            // expose them under a synthetic "Other" tab so orphan reports remain reachable.
            // The category counts sum to the number of assignment rows rather than to the
            // "All" count, which is de-duplicated - see setDistinctDeveloperReports().
            const knownCategoryIds = self.developerReportCategories.map(function (c) { return c.id; });
            const hasOrphanReports = self.developerReports.some(function (r) {
                return knownCategoryIds.indexOf(r.developer_report_category_id) === -1;
            });
            if (hasOrphanReports) {
                self.developerReportCategories.push({id: -1, category: 'Other'});
            }

            self.developerReportCategories.unshift({id: 0, category: 'All'});
            self.setDistinctDeveloperReports();
            self.setRespectiveCategoryReports(self.selectedReportCategory);
        });
    }

    developerSelectionChanged(developer) {
        const self = this;

        self.selectedDeveloper = developer;
        this.getDeveloperReports();
    }

    getSelectedClass(developerReportCategory) {
        const self = this;
        if (self.selectedReportCategory) {
            return self.selectedReportCategory.id === developerReportCategory.id ? 'selected' : '';
        } else {
            if (developerReportCategory.id === 0) {
                self.selectedReportCategory = developerReportCategory;
                return 'selected';
            }
        }
    }

    categorySelectionChanged(developerReportCategory) {
        const self = this;
        self.selectedReportCategory = developerReportCategory;
        self.setRespectiveCategoryReports(developerReportCategory);
    }

    /**
     * Catalogue description of the report an assignment row points at.
     *
     * @param {Object} developerReport A developer_reports row.
     * @returns {string} The description, or '--' when the report cannot be resolved.
     */
    getReportDescription(developerReport) {
        const self = this;

        let report = self.getReport(developerReport);

        return report ? report.description : '--';
    }

    /**
     * Resolves an assignment row to its catalogue report. The rows carry only report_id;
     * the name, code, description and download route all live on the catalogue.
     *
     * @param {Object} developerReport A developer_reports row.
     * @returns {Object|null} The catalogue report, or null when it cannot be resolved.
     */
    getReport(developerReport) {
        const self = this;

        // The catalogue and the developer's assignment rows are independent requests and
        // either can resolve first, so the rows can be bound before the catalogue is in.
        if (!self.reports || !developerReport) {
            return null;
        }

        let report = self.reports.find(function (report) {
            return report.id === developerReport.report_id;
        });

        return report ? report : null;
    }

    /**
     * Collapses the developer's report assignment rows to one row per distinct report,
     * for use by the "All" tab. Per-category tabs stay row-driven, so every assignment
     * remains reachable under its own category with its own alias.
     *
     * A developer may legally be assigned the same report under several categories
     * (there is no unique index on developer_reports), and each of those rows carries
     * its own alias, so one row has to represent the report on "All". The row whose
     * alias still matches the report's own catalogue name wins, falling back to the
     * first row in payload order. Without that rule an unrelated alias would represent
     * the report and it would never appear anywhere under its real name.
     *
     * @remarks Mirrors the App's behaviour so both platforms show the same "All" list.
     * @remarks The tie-break needs the report catalogue, which arrives from a separate
     *     unordered request, so this is a no-op until both payloads are present and is
     *     invoked from both callbacks. Until then - and if the catalogue request fails
     *     outright - the "All" tab falls back to the un-collapsed row list rather than
     *     rendering nothing.
     * @returns {void}
     */
    setDistinctDeveloperReports() {
        const self = this;

        if (!self.developerReports || !self.reports) {
            self.distinctDeveloperReports = null;
            return;
        }

        let representatives = {};
        self.developerReports.forEach(function (developerReport) {
            let current = representatives[developerReport.report_id];
            if (!current) {
                representatives[developerReport.report_id] = developerReport;
                return;
            }
            // First row wins unless a later one carries the report's own name.
            if (!self.isAliasMatchingReportName(current) && self.isAliasMatchingReportName(developerReport)) {
                representatives[developerReport.report_id] = developerReport;
            }
        });

        // Filter rather than read the map's values, to keep the payload's own order.
        self.distinctDeveloperReports = self.developerReports.filter(function (developerReport) {
            return representatives[developerReport.report_id] === developerReport;
        });

        // The catalogue may have landed after the "All" tab was already rendered.
        if (!self.selectedReportCategory || self.selectedReportCategory.id === 0) {
            self.setRespectiveCategoryReports(self.selectedReportCategory);
        }
    }

    /**
     * Whether an assignment row still carries the alias it was created with, i.e. the
     * catalogue name of the report it points at. The alias defaults to that name on
     * create and on sync, so a row that matches has not been renamed by Super Admin.
     *
     * @param {Object} developerReport A developer_reports row.
     * @returns {boolean} False when the report is not in the catalogue or was renamed.
     */
    isAliasMatchingReportName(developerReport) {
        const self = this;

        let report = self.getReport(developerReport);
        if (!report || !report.name || !developerReport.alias) {
            return false;
        }

        return String(developerReport.alias).trim().toLowerCase() === String(report.name).trim().toLowerCase();
    }

    setRespectiveCategoryReports(developerReportCategory) {
        const self = this;

        if (developerReportCategory === undefined || developerReportCategory === null || developerReportCategory.id === 0) {
            // "All" lists each report once; see setDistinctDeveloperReports().
            self.seletecCategoryDeveloperReports = self.distinctDeveloperReports || self.developerReports;
            return;
        }
        if (developerReportCategory.id === -1) {
            const knownIds = self._getKnownCategoryIds();
            self.seletecCategoryDeveloperReports = self.developerReports.filter(function (developerReport) {
                return knownIds.indexOf(developerReport.developer_report_category_id) === -1;
            });
            return;
        }
        self.seletecCategoryDeveloperReports = self.developerReports.filter(function (developerReport) {
            return developerReport.developer_report_category_id === developerReportCategory.id ? developerReport : null;
        });
    }

    getDeveloperCategoryReportCount(developerReportCategory) {
        const self = this;
        let count = 0;
        if (developerReportCategory.id === 0) {
            // Counts distinct reports, so this no longer sums to the category counts when
            // a report is assigned more than once; see setDistinctDeveloperReports().
            return (self.distinctDeveloperReports || self.developerReports || []).length;
        }
        if (developerReportCategory.id === -1) {
            const knownIds = self._getKnownCategoryIds();
            return self.developerReports.filter(function (r) {
                return knownIds.indexOf(r.developer_report_category_id) === -1;
            }).length;
        }
        self.developerReports.forEach(function (report) {
            report.developer_report_category_id === developerReportCategory.id ? count++ : null;
        });
        return count;
    }

    _getKnownCategoryIds() {
        const self = this;
        return self.developerReportCategories
            .filter(function (c) { return c.id !== 0 && c.id !== -1; })
            .map(function (c) { return c.id; });
    }

    /**
     * Search predicate for the reports listing: matches the assignment row's alias and
     * the report's catalogue code, case-insensitive, on substring. Mirrors what the App
     * searches, so the two platforms return the same cards.
     *
     * @remarks Replaces Angular's default object-wide comparator, which could only ever
     *     see the assignment row. The row carries `alias` but not `code` - the code lives
     *     on the catalogue and was resolved at render time only, so the code printed on
     *     every card ("R073") was not searchable. Alias search is unchanged.
     * @remarks The catalogue `name` is deliberately NOT searched. Where a row's alias has
     *     been changed, matching the underlying report's name would surface the card under
     *     a title it does not display - and for the mis-mapped rows on WEB-4019 a search
     *     for "IT User" would return three cards where the App returns one, re-creating
     *     the divergence this is meant to close. The listing is alias-driven, so search
     *     follows the alias.
     * @remarks Intentionally no longer matches the row's numeric ids. The default
     *     comparator stringified every property, so `id` and `report_id` matched
     *     incidentally and typing a digit surfaced unrelated cards.
     * @remarks Falls back to alias-only while the catalogue is still in flight, since
     *     that request is independent of the developer's rows and either can land first.
     * @param {Object} developerReport A developer_reports row.
     * @returns {boolean} True when the row matches, or when the search box is empty.
     */
    matchesReportSearch(developerReport) {
        const self = this;

        let searchText = self.searchText ? String(self.searchText).trim().toLowerCase() : '';
        if (!searchText) {
            return true;
        }
        if (!developerReport) {
            return false;
        }

        let report = self.reports ? self.getReport(developerReport) : null;

        return [
            developerReport.alias,
            report ? report.code : null
        ].some(function (value) {
            return !!value && String(value).toLowerCase().indexOf(searchText) !== -1;
        });
    }

    openDownloadReportModal(developerReport) {
        const self = this;
        self.selectedDownloadReport = null;
        self.selectedDownloadReport = self.getReport(developerReport);

        let statuses = null;
        if (self.selectedDownloadReport.show_status == 1)
            statuses = self.allReportStatus;
        else if (self.selectedDownloadReport.show_ura_status == 1)
            statuses = self.uraReportStatuses;
        else if (self.selectedDownloadReport.show_option_issued_status == 1)
            statuses = self.optionIssuedReportStatuses;

        self.reportParams = {
            statuses: statuses,
            // WEB-4823: null = "All law firms"
            law_firm_id: null
        };

        self.selected_property = '';
        self.$timeout(function () {
            $(".dashboard-select").niceSelect('update');
        });
        self.filtered_properties = [];
        self.onReportProjectsChanged();

        if (statuses)
            self.reportParams.statuses.forEach(function (value) {
                value.check = (value.name && value.name === 'All');
                self.reportParams.report_status = value.check? value.id : self.reportParams.report_status;
            });

        if (self.selectedDownloadReport) {
            $('#downloadReportModal').modal('show');
            self.selectedDownloadReport.alias = developerReport.alias;
            $('#from_date').datepicker({
                changeMonth: true,
                changeYear: true,
                dateFormat: 'dd/mm/yy'
            });
            $('#to_date').datepicker({
                changeMonth: true,
                changeYear: true,
                dateFormat: 'dd/mm/yy'
            });
        }
    }

    getStatusCheck() {
        const self = this;
        if (!self.selectedDownloadReport || !self.selectedDownloadReport.hasOwnProperty('code')) {
            return false;
        }
        if (self.selectedDownloadReport.code == 'URA2' || self.selectedDownloadReport.code == 'URA3')
            return false;
        if (self.selectedDownloadReport)
            return self.selectedDownloadReport.show_status || self.selectedDownloadReport.show_ura_status || self.selectedDownloadReport.show_option_issued_status;
    }

    getProperties() {
        const self = this;

        self.properties = [];
        let url = 'properties/customized';

        loading(true);
        self.SSHttpService.getAPIRequest(url, {
            offset: 0,
            limit: 1000,
            property_selected_fields: 'id,name,developer_id'
        }).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data && response.data.properties) {
                self.properties = response.data.properties.filter(function (property) {
                    return property.developer_id == self.selectedDeveloper.id;
                });
                self.$timeout(function () {
                    $(".dashboard-select").niceSelect('update');
                });
            }

        });
    }

    updateFilter() {
        const self = this;

        if (!self.selected_property) {
            self.filtered_properties = [];
        } else {
            // Don't process if property already filtered
            let property = self.filtered_properties.find(x => x.id == self.selected_property.id);
            if (property) {
                return;
            }

            self.filtered_properties.push(self.selected_property);
        }

        self.onReportProjectsChanged();
    }

    removeFilteredProperty(property_id) {
        const self = this;

        self.filtered_properties = $.grep(self.filtered_properties, function (obj) {
            return obj.id !== property_id;
        });

        self.onReportProjectsChanged();
    }

    /**
     * WEB-4823: whether a catalogue report has the law firm filter (Super Admin "Show Law Firm").
     *
     * @param {Object|null} report A `sec/super/reports` row.
     * @returns {boolean}
     */
    isLawFirmReport(report) {
        return !!report && (report.show_law_firm === true || Number(report.show_law_firm) === 1);
    }

    /**
     * WEB-4823: the project selection of the download modal changed — the law firm choice no longer
     * applies, so it goes back to "All law firms" and the list is rebuilt for the chosen project(s).
     *
     * @returns {void}
     */
    onReportProjectsChanged() {
        const self = this;

        if (self.reportParams) {
            self.reportParams.law_firm_id = null;
        }
        self.loadReportLawFirms();
    }

    /**
     * WEB-4823: the law firms assigned to the chosen project(s), for a report with show_law_firm.
     *
     * @returns {void} Fills self.reportLawFirms ([{id, name}], by name).
     *
     * @remarks GET sec/developer/law-firms/assigned?property_id= once per project (cached for the
     *          page). With several projects chosen the list is their union. A reply for an earlier
     *          selection is ignored. A failed lookup leaves "All law firms", which needs no list.
     */
    loadReportLawFirms() {
        const self = this;

        let seq = ++self.reportLawFirmsSeq;
        self.reportLawFirms = [];
        self.reportLawFirmsLoading = false;
        self.reportLawFirmsFailed = false;
        self.refreshReportLawFirmSelect();

        let propertyIds = (self.filtered_properties || []).map(property => property.id);
        if (!self.isLawFirmReport(self.selectedDownloadReport) || !propertyIds.length) {
            return;
        }

        let finish = function () {
            if (seq !== self.reportLawFirmsSeq) {
                return;
            }
            let byId = {};
            propertyIds.forEach(function (propertyId) {
                (self.reportLawFirmsByProperty[propertyId] || []).forEach(function (lawFirm) {
                    byId[lawFirm.id] = lawFirm;
                });
            });
            self.reportLawFirms = Object.keys(byId).map(id => byId[id])
                .sort((a, b) => String(a.name).localeCompare(String(b.name)));
            self.reportLawFirmsLoading = false;
            self.refreshReportLawFirmSelect();
        };

        let missing = propertyIds.filter(propertyId => !self.reportLawFirmsByProperty[propertyId]);
        if (!missing.length) {
            finish();
            return;
        }

        self.reportLawFirmsLoading = true;
        let pending = missing.length;
        missing.forEach(function (propertyId) {
            self.SSHttpService.getAPIRequest('sec/developer/law-firms/assigned', {property_id: propertyId}).then(function (response) {
                if (response instanceof Error || !response.data || !Array.isArray(response.data.law_firms)) {
                    console.warn('WEB-4823: Unable to load the law firms of project ' + propertyId + '.', response);
                    if (seq === self.reportLawFirmsSeq) {
                        self.reportLawFirmsFailed = true;
                    }
                } else {
                    self.reportLawFirmsByProperty[propertyId] = response.data.law_firms.map(lawFirm => ({
                        id: Number(lawFirm.id),
                        name: lawFirm.name,
                    }));
                }
                pending--;
                if (!pending) {
                    finish();
                }
            });
        });
    }

    /**
     * WEB-4823: the law firm select is a nice-select like the project select, so it is rebuilt after
     * its options (or the selection) change.
     *
     * @returns {void}
     */
    refreshReportLawFirmSelect() {
        const self = this;

        self.$timeout(function () {
            $("#law-firm-select").niceSelect('update');
        });
    }

    /**
     * WEB-4823: the law firm chosen for the report, or null for "All law firms" / a report without the filter.
     *
     * @returns {number|null}
     */
    getSelectedReportLawFirmId() {
        const self = this;

        if (!self.isLawFirmReport(self.selectedDownloadReport) || !self.reportParams || !self.reportParams.law_firm_id) {
            return null;
        }

        return Number(self.reportParams.law_firm_id) || null;
    }

    statusClicked(status) {
        const self = this;
        self.reportParams.report_status = status.id;

        self.reportParams.statuses.forEach(function (value) {
            value.check = value.id == status.id;
        });
    }

    validateReportParams() {
        const self = this;

        let check = true;
        let report = self.selectedDownloadReport;
        let skipFromDateCalenders = [
            'AR Aging Report',
            'Agings Report_03',
            'Sales and Collection Report (Allgreen - Custom)',
            'Unsold Unit Report'
        ];

        /** WEB-3169 Reports: Separate Settings for From and To Dates
        if (
            report.show_date_range &&
            !self.reportParams.from_date &&
            !skipFromDateCalenders.includes(report.name)
        ) {
            self.reportParamErrors.from_date = 'From date cannot be empty';
            check = false;
        }

        // To date required if show_date_range is true
        if (report.show_date_range && !self.reportParams.to_date) {
            self.reportParamErrors.to_date = 'To date cannot be empty';
            check = false;
        }

        if (report.show_property && !self.selected_property) {
            self.reportParamErrors.show_property = 'Select Property';
            check = false;
        }

        // Date consistency check (only if not in skip list)
        if (
            self.reportParams.from_date &&
            self.reportParams.to_date &&
            !skipFromDateCalenders.includes(report.name)
        ) {
            var fromDate = moment(self.reportParams.from_date, "DD/MM/YYYY");
            var toDate = moment(self.reportParams.to_date, "DD/MM/YYYY");

            if (fromDate.isAfter(toDate)) {
                self.reportParamErrors.from_date = 'From date cannot be later than To date';
                self.reportParamErrors.to_date = 'To date cannot be earlier than From date';
                check = false;
            }
        }
        **/

        if (report.show_date_from && !self.reportParams.from_date) {
            self.reportParamErrors.from_date = 'From date cannot be empty';
            check = false;
        }

        if (report.show_date_to && !self.reportParams.to_date) {
            self.reportParamErrors.to_date = 'To date cannot be empty';
            check = false;
        }

        if (report.show_date_from && report.show_date_to
                && self.reportParams.from_date && self.reportParams.to_date) {
            var fromDate = moment(self.reportParams.from_date, "DD/MM/YYYY");
            var toDate = moment(self.reportParams.to_date, "DD/MM/YYYY");

            if (fromDate.isAfter(toDate)) {
                self.reportParamErrors.from_date = 'From date cannot be later than To date';
                self.reportParamErrors.to_date = 'To date cannot be earlier than From date';
                check = false;
            }
        }

        // Property required if show_property is true
        if (report.show_property && !self.selected_property) {
            self.reportParamErrors.show_property = 'Select Property';
            check = false;
        }

        return check;
    }

    downloadReport() {
        const self = this;

        let url = '';
        let url_ping = '';

        if (!self.validateReportParams()) {
            return;
        }

        self.reportParamErrors.show_property = '';

        if (self.reportParams.from_date) {
            self.reportParams.from_date = moment(self.reportParams.from_date, "DD/MM/YYYY").format("YYYY-MM-DD");
        }
        if (self.reportParams.to_date) {
            self.reportParams.to_date = moment(self.reportParams.to_date, "DD/MM/YYYY").format("YYYY-MM-DD");
        }

        // WEB-3591: both helpers return a URL ending in a query separator and
        // carry no api_token; the same-origin proxy authenticates the request
        // server-side. The '&param=' appends below are therefore unchanged.
        if (self.selectedDownloadReport.is_old_report) {
            url = self.SSHttpService.getApiURL(self.selectedDownloadReport.url);
        } else {
            url = self.SSHttpService.getReportURL(self.selectedDownloadReport.url);
        }

        /** WEB-3169 Reports: Separate Settings for From and To Dates
        if (self.selectedDownloadReport.show_date_range) {
            url += '&from_date=' + self.reportParams.from_date;
            url += '&to_date=' + self.reportParams.to_date;
        }**/
        if (self.selectedDownloadReport.show_date_from) {
            url += '&from_date=' + self.reportParams.from_date;
        }
        if (self.selectedDownloadReport.show_date_to) {
            url += '&to_date=' + self.reportParams.to_date;
        }

        if (self.getStatusCheck()) {
            url += '&status=' + (self.reportParams.report_status || '');
        }

        // WEB-4823: only when a law firm is chosen; without it the report covers every law firm
        let lawFirmId = self.getSelectedReportLawFirmId();
        if (lawFirmId) {
            url += '&law_firm_id=' + lawFirmId;
        }

        if (self.selectedDownloadReport.allow_multiple_properties) {
            let selected_properties = '';
            self.filtered_properties.forEach(function (value) {
                selected_properties += value.id + ',';
            });
            selected_properties = selected_properties.slice(0, -1);
            url += '&property_id=' + selected_properties;
            self._addReportHistory(selected_properties);
            url_ping = window.open(encodeUrlWithParams(url), '_blank');
        } else {

            if (self.selectedDownloadReport.code == 'URA2') {
                let selected_property = '';
                self.filtered_properties.forEach(function (value) {
                    selected_property += value.id;
                    url += '&property_id=' + selected_property;
                    url += '&type=1';
                    url_ping = window.open(encodeUrlWithParams(url), '_blank');

                    url = url.replace('&type=1', '&type=2');
                    url_ping = window.open(encodeUrlWithParams(url), '_blank');

                    url = url.replace('&type=2', '&type=3');
                    url_ping = window.open(encodeUrlWithParams(url), '_blank');

                    url = url.replace('&type=3', '&type=4');
                    url_ping = window.open(encodeUrlWithParams(url), '_blank');
                    self._addReportHistory(selected_property);
                    // url_ping = window.open(encodeUrlWithParams(url), '_blank');
                    selected_property = '';
                });
            } else if (self.selectedDownloadReport.code == 'URA1') {
                let selected_property = '';
                self.filtered_properties.forEach(function (value) {
                    selected_property += value.id;
                    url += '&property_id=' + selected_property;
                    if (self.reportParams.report_status == 1) {
                        url += '&type=2';
                        url_ping = window.open(encodeUrlWithParams(url), '_blank');

                        url = url.replace('&type=2', '&type=3');
                        url_ping = window.open(encodeUrlWithParams(url), '_blank');
                    } else {
                        url += '&type=' + (self.reportParams.report_status || '');
                        url_ping = window.open(encodeUrlWithParams(url), '_blank');
                    }
                    self._addReportHistory(selected_property);
                    selected_property = '';
                });
            } else if (self.selectedDownloadReport.code == 'R050') {
                self.filtered_properties.forEach(function (_property) {
                    url += '&property_id=' + _property.id;
                    if (self.reportParams.report_status == 1) {
                        url += '&type=2';
                        url_ping = window.open(encodeUrlWithParams(url), '_blank');

                        url = url.replace('&type=2', '&type=3');
                        url_ping = window.open(encodeUrlWithParams(url), '_blank');

                        url = url.replace('&type=3', '&type=4');
                        url_ping = window.open(encodeUrlWithParams(url), '_blank');
                    } else {
                        url += '&type=' + (self.reportParams.report_status || '');
                        url_ping = window.open(encodeUrlWithParams(url), '_blank');
                    }
                });
            } else if (self.filtered_properties.length) {
                self.filtered_properties.forEach(function (_property) {
                    url += '&property_id=' + _property.id;
                    self._addReportHistory(_property.id);
                    url_ping = window.open(encodeUrlWithParams(url), '_blank');
                });
            } else {
                self._addReportHistory();
                url_ping = window.open(encodeUrlWithParams(url), '_blank');
            }
        }

        if (url_ping) {
            self.SSAlertService.success("Success!", "Download completed successfully");
        }
        $('#downloadReportModal').modal('hide');
    }

    _addReportHistory(propertyIds=null) {
        const self = this;

        let url = 'sec/developer/reports-history';

        let params = {
            name: self.selectedDownloadReport.alias,
            from_date: self.reportParams.from_date,
            to_date: self.reportParams.to_date,
            status: self.reportParams.report_status,
            allow_multiple_properties: self.selectedDownloadReport.allow_multiple_properties,
            property_ids: propertyIds
        };

        // WEB-4823: the law firm filter of a show_law_firm report (null = all law firms)
        if (self.isLawFirmReport(self.selectedDownloadReport)) {
            params.law_firm_id = self.getSelectedReportLawFirmId();
        }

        // WEB-3591: the API downloads this URL itself (ReportHistoryService),
        // so it must stay an absolute upstream URL rather than a proxy path.
        if (self.selectedDownloadReport.is_old_report) {
            params.url = self.SSHttpService.getUpstreamApiURL(self.selectedDownloadReport.url);
        } else {
            params.url = self.LARAVEL_REPORT_SERVER_URL + self.selectedDownloadReport.url;
        }

        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
            }
        });
    }
}

DeveloperReportsController.$inject = ['$scope', '$timeout', '$parse', 'SSHttpService', 'SSUtilService', 'SSAppService', 'SSAlertService', 'OTPService', 'SSUserService', 'SSDateService', 'SSAnalyticsService'];
app.controller('DeveloperReportsController', DeveloperReportsController);

